/*
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 应用常量数据配置中心
 * @Date: 2021-09-09 17:33:54
 * @LastEditTime: 2021-11-25 09:58:13
 */


import moment from 'moment';
export const orderState = {
  0: 'Draft',
  1: 'Active',
  2: 'Completed',
  3: 'Invalid',
  4: 'Accounting',
  5: 'Canceled',
  6: 'Paused'
};
export const keyOrderState = {
  0: 'Pending',
  1: 'Pending',
  2: 'Active',
  3: 'Completed',
  4: 'Invalid'
}
export const GKROrderState = {
  0: 'Submit',
  1: 'Received',
  2: 'Active',
  3: 'Completed',
  4: 'Invalid'
}
export function timeDeal(data){
  return moment(data).format('MM-DD')
}
export function formatDiff(data, state) {
  const obj = {
    diff: '',
    className: 'ranking-text'
  }
  if (data > 0) {
    obj.diff = state !== 0 ? ' (+' + data + ')' : ''
    obj.className = 'ranking-plus'
  } else if (data < 0) {
    obj.diff = state !== 0 ? ' (' + data + ')' : ''
    obj.className = 'ranking-minus'
  } else if (data === 'out') {
    obj.diff = 'out'
    obj.className = 'ranking-error'
  }
  return obj
}
export const deliveryTypeArray = [
  {
    value: '24h',
    src: null,
    alt: null,
    name: 'Spread Installs Within 24h'
  },
  {
    value: 'once',
    src: null,
    alt: null,
    name: 'All Installs At Once'
  }
]
export const starsArray = [{
  value: '80',
  src: null,
  alt: null,
  name: '5☆+4☆ positive rates (80% + 20%)'
},
{
  value: '100',
  src: null,
  alt: null,
  name: '5☆ positive rates'
},
{
  value: '60',
  src: null,
  alt: null,
  name: '3☆ positive rates'
},
]
export const inputInstallCountValidate = function(val, min = 0) {
  const n = parseInt(val, 10)
  if (n > min && val.toString() === n.toString()) {
    return ''
  } else {
    return `Input a number large than ${min}`
  }
}
export const installCountValidate = function(val, min = 10) {
  const n = parseInt(val, 10)
  if (n >= min && val.toString() === n.toString()) {
    return ''
  } else {
    return `The minimum number of installations per day is ${min}.`
  }
}
export const EnFormatDate = function(data,showYear=false) {
  const date = new Date(data)
  const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Spt', 'Oct', 'Nov', 'Dec']
  const year = date.getFullYear() // year
  const month = monthArr[date.getMonth()] // 月
  const day = date.getDate() // 日
  let ret = month + ' ' + day
  if (showYear) {
    ret += ' ' + year
  }
  return ret

}

//应用类型
export const STORETYPES = {
  'All':null,
  'Google Play':1,
  'App Store-iPad':3,
  'App Store-iPhone':2
}

//服务类型
export const SERVICETYPE =  {
  DIRECT_INSTALL: 0,
  KEYWORD_INSTALL: 1,
  RATING: 2,
  REVIEW: 3,
  ASO: 4,
  GUARANTEED_REVIEWS: 5,
  COMPOSITE: 8,
  APP_REVIEWS_LIKES: 6,
  KEYWORD_RANKING_ACQUISITION: 7,
  SMART_CAMPAIGN:8,
  ASO_SERVICE:9,
  INSTALLS_PACKAGE:10,
  GREVIEW: 5,
}

// 后端的服务类型，不同于 网页服务类型
export const BACKENDSERVICETYPE = {
  PACKAGE: 0,
  KEYWORD: 1,
  RATE: 2,
  REVIEW: 3,
  GUARANTEE: 4,
  GUARANTEE_REVIEW: 5,
  COMPOSITE: 8,
  LREVIEW: 6,
  KEYWORD_ACQU: 7,
  SMART_CAMPAIGN:8,
  ASO_SERVICE:9,
  INSTALLS_PACKAGE:10,
  GREVIEW: 5,
}

